import { useEffect } from 'react';
import { trackLink } from '@vfit/shared/data-access';

export const useTagging = () => {
  // region Tagging Simple buttons

  const trackSimpleButtonInfo = (event: any) => {
    trackLink(event['target']?.['textContent']);
  };

  const simpleButtonTagging = (widgetClass: string, removeEvent?: boolean) => {
    const simpleButtonsInfo = document.querySelectorAll(widgetClass);
    simpleButtonsInfo.forEach((sB) => {
      const buttons = sB.querySelectorAll('button');
      buttons.forEach((button) => {
        if (removeEvent) button.removeEventListener('click', trackSimpleButtonInfo);
        else button.addEventListener('click', trackSimpleButtonInfo);
      });
    });
  };

  // endregion

  // region Tagging search button
  const trackSearchButton = (event: any) => {
    trackLink(event['target']?.['textContent'], 'users', 'click', [
      'ui-interaction',
      'search_apply',
    ]);
  };

  const searchButtonTagging = (removeEvent?: boolean) => {
    const searchButton = document.getElementById('multi-selection-filter-search-button');
    if (removeEvent) searchButton?.removeEventListener?.('click', trackSearchButton);
    else searchButton?.addEventListener?.('click', trackSearchButton);
  };
  // endregion

  useEffect(() => {
    searchButtonTagging();
    simpleButtonTagging('.card-info-widget');
    simpleButtonTagging('.faq-widget');
    simpleButtonTagging('.text-info-widget');
    simpleButtonTagging('.app-qr-widget');
    return () => {
      searchButtonTagging(true);
      simpleButtonTagging('.card-info-widget', true);
      simpleButtonTagging('.faq-widget', true);
      simpleButtonTagging('.text-info-widget', true);
      simpleButtonTagging('.app-qr-widget', true);
    };
  }, []);

  return null;
};
